import {
  RATIO_CLASS_A,
  RATIO_CLASS_B,
  RATIO_RETRIEIVAL_PERCENTAGE,
} from '../constants/price';

export const convertGBToTB = (valueInGB: number) => {
  return Math.round(valueInGB / 1000);
};

export const calculateClassAFromUsage = (usage: number) => {
  return Math.round(usage * RATIO_CLASS_A);
};

export const calculateClassBFromUsage = (usage: number) => {
  return Math.round(usage * RATIO_CLASS_B);
};

export const calculateRetrievalFromUsage = (usage: number) => {
  return Math.round((usage * RATIO_RETRIEIVAL_PERCENTAGE) / 100);
};

export const convertInMillion = (value: number) => {
  return (value / 1000000).toFixed(1);
};
